import { AxiosResponse } from "axios";
import { ButtonWarning } from "components/Atoms/Button";
import DeleteDialog from "components/deleteDialog";
import React, { useContext } from "react";
import { SidePanelContext } from "./SidePanelContext";

interface Props {
  apiCall: () => Promise<AxiosResponse<any, any>>;
  onSuccess?: () => void;
}

export const SidePanelDeleteEntryButton = (props: Props) => {
  const sidePanelContext = useContext(SidePanelContext);
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false);

  const onDelete = async () => {
    setIsDeleting(true);
    const resp = await props.apiCall();
    if (resp.data.hasErrors) {
      setIsDeleting(false);
      return;
    }
    if (sidePanelContext.hasBack) {
      sidePanelContext.back();
    } else {
      sidePanelContext.closePanel();
    }
    setIsDeleting(false);
    props.onSuccess?.();
  }

  return <>
    <DeleteDialog
      isOpen={isDeleting}
      onDelete={onDelete}
      handleClose={() => { setIsDeleting(false); }}
      message={RESX.GeneralWarnings.DeleteSure}
    />
    <ButtonWarning
      label={RESX.Buttons.btnDelete}
      onClick={() => { setIsDeleting(true); }}
    />
  </>
}